export const REGISTER_CONTRACT_ID = 'REGISTER_CONTRACT_ID';
export const CLEAR_CONTRACT_ID_ERROR = 'CLEAR_CONTRACT_ID_ERROR';
export const SET_CONTRACT_ID_ERROR = 'SET_CONTRACT_ID_ERROR';
